import React from 'react';
import { FaHome, FaCalendar, FaChartBar, FaCaretDown, FaBriefcase } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './common.css';
import './style.css';

export default function SideNave({ isSidebarCollapsed, toggleSidebar }) {
  const [isFinancialYearOpen, setIsFinancialYearOpen] = React.useState(false); // Track the financial year menu open/closed state
 
  // const handleNavClick = () => {
  //   if (!isSidebarCollapsed) {
  //     toggleSidebar(); // Only collapse if it's open
  //   }
  // };

  const toggleFinancialYearMenu = () => {
    setIsFinancialYearOpen((prev) => !prev); // Toggle the state of the Financial Year menu
  };

  return (
    
    <div className={`SideNave ${isSidebarCollapsed ? 'collapsed' : ''}`}>
      <div id="layoutSidenav_nav">
        <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
          <div className="sb-sidenav-menu">
            <div className="nav">
              {/* Core Section */}
              <div className="sb-sidenav-menu-heading">
                <span>Core</span>
              </div>
              <Link className="nav-link" to="/dashboard" 
              // onClick={handleNavClick}
              >
                <div className="sb-nav-link-icon">
                  <FaHome />
                </div>
                {!isSidebarCollapsed && <span>Dashboard</span>}
              </Link>

              {/* Divider when sidebar is collapsed */}
              {isSidebarCollapsed && <div className="sidebar-divider"></div>}

              {/* Activity Section */}
              <div className="sb-sidenav-menu-heading">
                <span>Activity</span>
              </div>

              {/* Financial Year Section with Submenu */}
              <div className="nav-link collapsed" onClick={toggleFinancialYearMenu} style={{ cursor: 'pointer' }}>
                <div className="sb-nav-link-icon">
                  <FaCalendar />
                </div>
                {!isSidebarCollapsed && (
                  <>
                    <span>Financial Year</span>
                    <div className="sb-sidenav-collapse-arrow">
                      <FaCaretDown />
                    </div>
                  </>
                )}
              </div>

              

              <div className={`collapse ${isFinancialYearOpen ? 'show' : ''}`}>
                <nav className="sb-sidenav-menu-nested nav nested-menu">
                  {/* Link with State */}
                  <Link
                    className="nav-link submenu-item"
                    to="/project"
                    // onClick={handleNavClick}
                    state={{ financialYear: "2026-27" }}  // Passing the state here
                  >
                    <div className="sb-nav-link-icon">
                    </div>
                    2026-27 {/* Submenu Item */}
                  </Link>
                </nav>
              </div>


               {/* <div className={`collapse ${isFinancialYearOpen ? 'show' : ''}`}>
                <nav className="sb-sidenav-menu-nested nav nested-menu">
                
                  <Link
                    className="nav-link submenu-item"
                    to="/project"
                    // onClick={handleNavClick}
                    state={{ financialYear: "2025-26" }}  // Passing the state here
                  >
                    <div className="sb-nav-link-icon">
                    </div>
                    2025-26 
                  </Link>
                </nav>
              </div>   */}
              

              <Link className="nav-link" to="/cvs" 
              // onClick={handleNavClick}
              >
                <div className="sb-nav-link-icon">
                  <FaBriefcase /> {/* Icon for CVs */}
                </div>
                {!isSidebarCollapsed && <span>Manage CVs</span>} {/* Show text only when not collapsed */}
              </Link>

              <Link className="nav-link" to="/report" 
              // onClick={handleNavClick}
              >
                <div className="sb-nav-link-icon">
                  <FaChartBar />
                </div>
                {!isSidebarCollapsed && <span>Reports</span>}
              </Link>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
}
